import { GSPCommonObject } from "../../../common-model";
import {I18nUtil} from "../../../i18n/i18n-service";

/**
 * 关联条件定义
 */
export class AssoCondition {
    /**
     * 关联条件编号
     */
    id: string;
    /**
     * 左侧节点编号
     */
    leftNodeCode: string;
    /**
     * 左侧字段LabledId
     */
    leftField: string;
    /**
     * 左侧字段的ID
     */
    leftElemenetId: string;

    /**
     * 操作符
     */
    operator: string;

    /**
     * 右侧节点编号
     */
    rightNodeCode: string;
    /**
     * 右侧字段LabelID
     */
    rightField: string;
    /**
     * 右侧类型的ID
     */
    rightElementId: string;
    /**
     * 比较值
     */
    value: string;
    /**
     * 关联条件类型
     */
    assoConditionType: AssoConditionType;
    /**
     * 左侧关联对象
     */
    leftNodeObject: GSPCommonObject;
    /**
     * 右侧关联对象
     */
    rightNodeObject: GSPCommonObject;
    /**
     * 左侧关联对象名称
     */
    leftNodeName: string;
    /**
     * 右侧关联对象名称
     */
    rightNodeName: string;
    /**
     * 左侧字段名称
     */
    leftFieldName: string;
    /**
     * 右侧字段名称
     */
    rightFieldName: string;
  }

export enum AssoConditionType {
    /**
     * 值类型
     */
    AssoValue = 'AssoValue',
    /**
     * 字段类型
     */
    AssoField = 'AssoField'
  }


export const AssoConditionTypes: Array<{
    index: number, value: AssoConditionType| string, text: string
  }> = [
    {
      index: 0, value:AssoConditionType.AssoValue, text:I18nUtil.instant("AssociationValue")
    },
    {
      index: 1, value: AssoConditionType.AssoField, text: I18nUtil.instant("AssociationField")
    }
  ];
